export default __webpack_public_path__ + "static/media/rider.36774bd3.png";